// Hook para notificações toast

import { useCallback } from 'react';

export function useToast() {
  const showToast = useCallback((message, type = 'info', duration = 4000) => {
    // Integração com react-hot-toast ou similar
    console.log(`[${type.toUpperCase()}] ${message}`);
    
    // Aqui você integraria com react-hot-toast:
    // toast[type](message, { duration });
  }, []);

  return {
    showToast,
    success: (message) => showToast(message, 'success'),
    error: (message) => showToast(message, 'error'),
    warning: (message) => showToast(message, 'warning'),
    info: (message) => showToast(message, 'info'),
  };
}
